import {
    SET_BLOG,

    SET_ERROR, SET_EVENT, SET_EVENT_CAT, SET_EXHIBITION, SET_GALLERY,
    SET_LOADING, SET_OPENING, SET_PROJECTS,
    SET_RESET, SET_SINGLE, SET_SOCIAL_RESPONSIBILITIES
} from "./mutation_types";

export default {
    [SET_EVENT](state,event){
        state.event=event.data;
    },
    [SET_GALLERY](state,event){
        state.gallery=event.data;
    },
    [SET_OPENING](state,event){
        state.event=event.data;
    },
    [SET_EXHIBITION](state,event){
        state.event=event.data;
    },
    [SET_SOCIAL_RESPONSIBILITIES](state,resource){
        state.socialResponsibilities=resource.data;
    },
    [SET_BLOG](state,resource){
        state.blog=resource.data;
    },
    [SET_PROJECTS](state,resource){
        state.projects=resource.data;
    },
    [SET_SINGLE](state,resource){
        state.single=resource.data;
    },

    [SET_EVENT_CAT](state,resource){

        for (let i=0;i<resource.data.categories.length;i++){
            var item = resource.data.categories[i];
            if (item.title==="گواهینامه ها و افتخارات"){
                state.eventCat=item.sub_categories;
            }
        }

    },

    [SET_ERROR](state, error) {
        state.error = error;
    },
    [SET_LOADING](state, loading) {
        state.loading = loading;
    },
    [SET_RESET](state) {
        state.mornsunResource = [];
        state.resource = [];
        state.chinaResource = [];
        state.mouserResource = [];
    }
};

